import { c as _c } from "react/compiler-runtime";
import { Facet, SelectedFacet, Sort } from '../facets/interfaces';
import PopupComponent, { PopupType } from '../popup/popup.component';
import React, { useState, useTransition } from 'react';
import ButtonComponent from '../button/button/button.component';
import { ButtonType } from '../button/types/ButtonType';
import FacetsComponent from '../facets/facets/facets.component';
import { NamespacedIntl } from '@spa/lib/i18n/common/NamespacedIntl';
import SelectedFacetsComponent from '../selected-facets/selected-facets.component';
import SortsComponent from '../sorts/sorts.component';
import styles from './product-list-filter.component.module.scss';
import useNamespacedIntl from '@spa/lib/i18n/client/hooks/useNamespacedIntl';
export interface Props {
  readonly id: string;
  readonly facets: ReadonlyArray<Facet>;
  readonly selectedFacets: ReadonlyArray<SelectedFacet>;
  readonly selectedSortCode: string;
  readonly sorts: ReadonlyArray<Sort>;
  readonly totalCount: number;
  readonly isDummy?: boolean;
}
const ProductListFilter: React.FC<Props> = t0 => {
  const $ = _c(20);
  const {
    id,
    facets,
    selectedFacets,
    selectedSortCode,
    sorts,
    totalCount,
    isDummy: t1
  } = t0;
  const isDummy = t1 === undefined ? false : t1;
  const [showMobileFilters, setShowMobileFilters] = useState(false);
  const [, startTransition] = useTransition();
  const {
    formatMessage
  } = useNamespacedIntl("product-list");
  let t2;
  if ($[0] !== formatMessage || $[1] !== selectedFacets.length) {
    t2 = function filterButtonText() {
      const base = formatMessage("filters");
      return selectedFacets.length > 0 ? `${base} (${selectedFacets.length})` : base;
    };
    $[0] = formatMessage;
    $[1] = selectedFacets.length;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const filterButtonText = t2;
  let t3;
  if ($[3] !== formatMessage || $[4] !== selectedFacets.length || $[5] !== totalCount) {
    t3 = function showButtonText() {
      return selectedFacets.length > 0 ? formatMessage("showXResults", {
        totalCount
      }) : formatMessage("showAllResults");
    };
    $[3] = formatMessage;
    $[4] = selectedFacets.length;
    $[5] = totalCount;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const showButtonText = t3;
  if (isDummy) {
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <div className={styles["product-list-filter__dummy"]}><p data-testid="dummy.text">BEISPIEL</p></div>;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    return t4;
  }
  let t4;
  if ($[8] !== facets || $[9] !== filterButtonText || $[10] !== formatMessage || $[11] !== id || $[12] !== selectedFacets || $[13] !== selectedSortCode || $[14] !== showButtonText || $[15] !== showMobileFilters || $[16] !== sorts || $[17] !== startTransition || $[18] !== totalCount) {
    t4 = totalCount > 0 && <><div className={styles["product-list-filter__mobile-actions"]}><div className={styles["product-list-filter__mobile-filters-button"]}><ButtonComponent buttonType={ButtonType.TERTIARY} text={filterButtonText()} iconLeft={{
            src: "/assets/icons/filter.svg",
            alt: "filter-icon",
            width: 25,
            height: 24,
            unoptimized: true
          }} onClick={() => startTransition(() => setShowMobileFilters(true))} /></div><div className={styles["product-list-filter__mobile-sorts"]}><SortsComponent id={id} sorts={sorts} selectedSortCode={selectedSortCode} stretchToParent={true} /></div></div><div className={styles["product-list-filter__mobile-filters-popup"]}>{showMobileFilters && <PopupComponent isOpen={showMobileFilters} title={formatMessage("filters")} footerContent={<ButtonComponent buttonType={ButtonType.SECONDARY} text={showButtonText()} onClick={() => setShowMobileFilters(false)} />} onClosed={() => {
          setShowMobileFilters(false);
        }} popupType={PopupType.FULLSCREEN}><SelectedFacetsComponent selectedFacets={selectedFacets} /><FacetsComponent facets={facets} selectedFacets={selectedFacets} /></PopupComponent>}</div><div className={styles["product-list-filter__filters-wrapper"]}><FacetsComponent facets={facets} selectedFacets={selectedFacets} /></div></>;
    $[8] = facets;
    $[9] = filterButtonText;
    $[10] = formatMessage;
    $[11] = id;
    $[12] = selectedFacets;
    $[13] = selectedSortCode;
    $[14] = showButtonText;
    $[15] = showMobileFilters;
    $[16] = sorts;
    $[17] = startTransition;
    $[18] = totalCount;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  return t4;
};
export default ProductListFilter;